import getRemBase from './getRemBase';

const setMobileFixedBottomButtonHeight = () => {
	const mobileFixedBottomButton = document.querySelector(
		'.mobile-fixed-bottom-button'
	);

	const mobileFixedBottomButtonHeight = mobileFixedBottomButton
		? mobileFixedBottomButton.offsetHeight
		: 0;

	document.body.style.setProperty(
		'--mobile-fixed-bottom-button-height',
		`${mobileFixedBottomButtonHeight / getRemBase()}rem`
	);
};

export default setMobileFixedBottomButtonHeight;
